import { FC, useEffect, useRef, useState } from 'react'
import Select from 'react-select'
import styles from './FilterPanelEstablishment.module.css'
import glassIcon from '../../assets/icons/glass.svg'
import { useMediaQuery } from 'react-responsive'
import DropDown from '../DropDown/DropDown'

import 'react-datepicker/dist/react-datepicker.css'
import '../../styles/common/datePicker.css'
import { useNavigate } from 'react-router-dom'
import { useAppDispatch, useAppSelector } from '../../redux/types/types'

import { placesPerPage } from '../../constants/constants'
import { waitTimer } from '../../utils/waitTimer'
import CalendarComponent from '../CalendarComponent/CalendarComponent'
import { getDaDataCity } from '../../redux/actions/daDataAction'
import { Suggestion } from '../../pages/RegistrationPage/RegistrationPage'
import {
  getEstablishmentFromCompany,
  getEstablishments,
} from '../../redux/actions/establishmentsAction'

export type SearchPanelPropsType = {
  currentPage: number
}

type OptionType = {
  value: string
  label: string
}

const FilterPanelEstablishment: FC<SearchPanelPropsType> = ({ currentPage }) => {
  const [errorMessage, setErrorMessage] = useState('')
  const [city, setCity] = useState('')
  const { daDataCity } = useAppSelector((state) => state.daData)
  const [citySuggestions, setCitySuggestions] = useState<Suggestion[]>([])

  const [openDate, setOpenDate] = useState(false)
  const [openEndDate, setOpenEndDate] = useState(false)
  const [openTime, setOpenTime] = useState(false)

  const [startDateString, setStartDateString] = useState('')
  const [finishDateString, setFinishDateString] = useState('')

  const [timeStart, setTimeStart] = useState<Date | null>(null)
  const [timeFinish, setTimeFinish] = useState<Date | null>(null)

  const [peopleCount, setPeopleCount] = useState('')
  const isMobile = useMediaQuery({ query: '(max-width: 767px)' })
  const { token, userRole } = useAppSelector((state) => state.auth)
  const { error } = useAppSelector((state) => state.places)

  const dispatch = useAppDispatch()
  const navigate = useNavigate()

  const customInput = <input type='text' placeholder='Когда?' className={styles.datePickerInput} />

  const getFormatDate = (time: Date | null) => {
    if (time !== null) {
      const hours: string = time.getHours().toString().padStart(2, '0')
      const minutes: string = time.getMinutes().toString().padStart(2, '0')
      const seconds: string = time.getSeconds().toString().padStart(2, '0')
      return `${hours}:${minutes}:${seconds}`
    } else {
      return null
    }
  }

  const handleSearch = async () => {
    if (city || startDateString || timeStart || finishDateString || timeFinish || peopleCount) {
      let startDateAndTime
      let finishDateAndTime

      if (startDateString !== '' || finishDateString !== '') {
        if (startDateString === '' || finishDateString === '') {
          setErrorMessage('Дата начала и Дата конца обязательны для ввода')
          waitTimer(() => setErrorMessage(''))
          return
        }
      }

      if (startDateString !== '' && timeStart !== null) {
        startDateAndTime = `${startDateString.split('.').reverse().join('-')} ${getFormatDate(
          timeStart,
        )}`
      }

      if (startDateString !== '' && timeStart === null) {
        const now = new Date()
        startDateAndTime = `${startDateString.split('.').reverse().join('-')} ${getFormatDate(now)}`
      }

      if (finishDateString !== '' && timeFinish !== null) {
        finishDateAndTime = `${finishDateString.split('.').reverse().join('-')} ${getFormatDate(
          timeFinish,
        )}`
      }

      if (finishDateString !== '' && timeFinish === null) {
        const now = new Date()
        finishDateAndTime = `${finishDateString.split('.').reverse().join('-')} ${getFormatDate(
          now,
        )}`
      }

      const resultAction = await dispatch(
        getEstablishments({
          token,
          page: currentPage,
          itemsPerPage: placesPerPage,
          startDate: startDateAndTime,
          endDate: finishDateAndTime,
          city: city,
          peopleCount: peopleCount,
        }),
      )

      if (getEstablishments.rejected.match(resultAction)) {
        return
      } else {
        navigate('/establishment-page/', {
          state: {
            startDateAndTime,
            finishDateAndTime,
            city,
            peopleCount,
            startDateString,
            finishDateString,
            startTime: timeStart,
            finishTime: timeFinish,
          },
        })
      }
      return
    }

    if (
      !city &&
      !startDateString &&
      !finishDateString &&
      !timeStart &&
      !timeFinish &&
      !peopleCount
    ) {
      if (
        userRole === 'directorPlace' ||
        userRole === 'employeePlace' ||
        userRole === 'employeeAgent' ||
        userRole === 'directorAgent'
      ) {
        dispatch(
          getEstablishmentFromCompany({
            token,
            page: 1,
            itemsPerPage: 1000,
          }),
        )
      } else {
        dispatch(getEstablishments({ token, page: currentPage, itemsPerPage: 20 }))
      }
    }
  }

  const handleCityInputChange = (inputValue: string) => {
    if (inputValue.trim().length >= 1) {
      setCity(inputValue)
      dispatch(getDaDataCity({ query: inputValue }))
    } else {
      setCitySuggestions([])
    }

    return inputValue
  }

  const handleSelectCity = (selectedOption: OptionType | null) => {
    if (selectedOption) {
      setCity(selectedOption.value)
    } else {
      setCity('')
    }
  }

  const handleTimeStartChange = (time: any) => {
    setTimeStart(time)
  }

  const handleTimeFinishChange = (time: any) => {
    setTimeFinish(time)
  }

  const handlePeopleCountChange = (e: any) => {
    setPeopleCount(e.target.value)
  }

  const handleCloseAllDropDowns = () => {
    setOpenDate(false)
    setOpenEndDate(false)
    setOpenTime(false)
  }

  const openDateDropDown = (e: any) => {
    e.stopPropagation()
    setOpenDate(!openDate)
    if (openEndDate) {
      setOpenEndDate(false)
    }
  }

  const openEndDateDropPdown = (e: any) => {
    e.stopPropagation()
    setOpenEndDate(!openEndDate)
    if (openDate) {
      setOpenDate(false)
    }
  }

  const dropdownDataRef = useRef<HTMLDivElement>(null)
  const dropdownDataEndRef = useRef<HTMLDivElement>(null)
  const dropdownTimeRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (dropdownDataRef.current && !dropdownDataRef.current.contains(event.target as Node)) {
        setOpenDate(false)
      }
    }

    window.addEventListener('click', handleClickOutside)

    return () => {
      window.removeEventListener('click', handleClickOutside)
    }
  }, [])

  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (dropdownTimeRef.current && !dropdownTimeRef.current.contains(event.target as Node)) {
        setOpenTime(false)
      }
    }

    window.addEventListener('click', handleClickOutside)

    return () => {
      window.removeEventListener('click', handleClickOutside)
    }
  }, [])

  useEffect(() => {
    setCitySuggestions(daDataCity)
  }, [daDataCity])

  const cityOptions: OptionType[] =
    citySuggestions?.map((suggestion: Suggestion) => ({
      value: suggestion.data.city,
      label: suggestion.data.city,
    })) || []

  return (
    <div className={styles.searchPanelContainer}>
      <div className={styles.cityBlock}>
        <Select
          className={styles.reactSelect}
          classNamePrefix='react-select'
          placeholder='Введите город'
          value={city ? { value: city, label: city } : null}
          options={cityOptions}
          onChange={handleSelectCity}
          onInputChange={handleCityInputChange}
          onFocus={handleCloseAllDropDowns}
          isClearable
          noOptionsMessage={() => 'Город не найден'}
          loadingMessage={() => 'Поиск...'}
          styles={{
            control: (provided) => ({
              ...provided,
              border: 'none',
              boxShadow: 'none',
              minHeight: 'auto',
              backgroundColor: 'transparent',
            }),
            menu: (provided) => ({
              ...provided,
              right: 0,
            }),
            input: (provided) => ({
              ...provided,
              margin: 0,
              padding: 0,
              height: isMobile ? 40 : 20,
            }),
            valueContainer: (provided) => ({
              ...provided,
              padding: 0,
            }),
            dropdownIndicator: (provided) => ({
              ...provided,
              padding: 0,
            }),
            clearIndicator: (provided) => ({
              ...provided,
              padding: 0,
            }),
            indicatorSeparator: () => ({
              display: 'none',
            }),
          }}
        />
      </div>

      <div className={styles.dateBlock} onClick={(e) => openDateDropDown(e)}>
        <span style={error || errorMessage ? { color: '#EC1A3C' } : {}} className={styles.input}>
          {startDateString || 'Дата и время начала'}
        </span>
        <DropDown ref={dropdownDataRef} className={styles.dropDown} open={openDate}>
          <CalendarComponent
            startDate={true}
            timeStart={timeStart}
            timeFinish={timeFinish}
            customInput={customInput}
            openTime={openTime}
            handleTimeStartChange={handleTimeStartChange}
            handleTimeFinishChange={handleTimeFinishChange}
            startDateString={startDateString}
            finishDateString={finishDateString}
            setStartDateString={setStartDateString}
            setFinishDateString={setFinishDateString}
          />
          {error && <div className={styles.errorBlock}>{error}</div>}
          {errorMessage && <div className={styles.errorBlock}>{errorMessage}</div>}
        </DropDown>
      </div>
      <div className={styles.dateBlock} onClick={(e) => openEndDateDropPdown(e)}>
        <span style={error || errorMessage ? { color: '#EC1A3C' } : {}} className={styles.input}>
          {finishDateString || 'Дата и время окончания'}
        </span>
        <DropDown ref={dropdownDataEndRef} className={styles.dropDownEnd} open={openEndDate}>
          <CalendarComponent
            endDate={true}
            timeStart={timeStart}
            timeFinish={timeFinish}
            customInput={customInput}
            openTime={openTime}
            handleTimeFinishChange={handleTimeFinishChange}
            handleTimeStartChange={handleTimeStartChange}
            startDateString={startDateString}
            finishDateString={finishDateString}
            setStartDateString={setStartDateString}
            setFinishDateString={setFinishDateString}
          />
          {error && <div className={styles.errorBlock}>{error}</div>}
          {errorMessage && <div className={styles.errorBlock}>{errorMessage}</div>}
        </DropDown>
      </div>
      <div className={styles.guestsBlock}>
        <input
          className={styles.input}
          type='text'
          placeholder='Кол-во гостей'
          value={peopleCount}
          onChange={handlePeopleCountChange}
          onFocus={handleCloseAllDropDowns}
        />
      </div>

      <div className={styles.glassBlock} onClick={handleSearch}>
        <img className={styles.glassIcon} src={glassIcon} alt='glass' />
      </div>

      {error && <div className={styles.errorBlock}>{error}</div>}
      {errorMessage && <div className={styles.errorBlock}>{errorMessage}</div>}
    </div>
  )
}

export default FilterPanelEstablishment
